export const SET_VAR_VALUE = "SET_VAR_VALUE";
export const SET_INVENTORY_CODE_ITEM = "SET_INVENTORY_CODE_ITEM";
export const SET_LOCATION_CODE ="SET_LOCATION_CODE"

export const setVarValue = (payload) => ({
  type: SET_VAR_VALUE,
  payload,
});

export const setInventoryCodeItem = (payload) => ({
  type: SET_INVENTORY_CODE_ITEM,
  payload,
});

export const setLocationCode = (payload) =>({
  type: SET_LOCATION_CODE,
  payload,
})
